@if (
  {
    instanceLogo: instanceLogo$ | async,
    products: products$ | async,
  };
  as viewContext
) {
  <nav
    class="ImproverNavbar"
    role="navigation">
    <imp-button
      cdkMonitorSubtreeFocus
      (cdkFocusChange)="!!$event && a11yButtonFocusChange()"
      [impContextMenu]="contextMenu"
      class="cdk-visually-hidden ImproverNavbar-a11yButton">
    </imp-button>
    <div
      class="ImproverNavbar-brandLogo"
      [attr.id]="logoContainerId">
      <a
        tabindex="0"
        class="ImproverNavbar-brandLogoLink"
        [routerLink]="logoLink">
        <img
          id="improver_logo"
          class="ImproverNavbar-logo"
          [class.is-default]="viewContext.instanceLogo === defaultLogoUrl"
          [app-desktop-class]
          [app-mobile-class]
          [ngSrc]="viewContext.instanceLogo"
          width="112"
          height="25"
          [alt]="logoPlaceholder" />
      </a>
      @if (!profileMenu()) {
        <div
          *app-desktop
          class="ImproverNavbar-companyName">
          {{ instanceName$ | async }}
        </div>
      }
    </div>
    @if (distractionFreeMode) {
      <div
        class="ImproverNavbar-distractionFreeActions"
        [app-mobile-class]
        [@distractionFreeModeToggle]>
        <div class="ImproverNavbar-item is-close">
          <app-nav-button
            [icon]="['fas', 'xmark-large']"
            (clickEvent)="close()">
          </app-nav-button>
        </div>
      </div>
    }

    @if (userActionsVisible && !distractionFreeMode) {
      <div
        class="ImproverNavbar-actions"
        [@distractionFreeModeToggle]>
        @if (!profileMenu()) {
          @defer (when !profileMenu()) {
            <div class="ImproverNavbar-item is-search">
              <app-improver-global-search class="ImproverNavbar-itemSearch" />
            </div>

            @if (hasPermissionToManageOwnHours() && isClockingProductAvailable()) {
              @defer (on idle) {
                <div class="ImproverNavbar-item">
                  <fu-hours-time-clock-in-out-timer />
                </div>
              }
            }

            <div class="ImproverNavbar-item">
              <app-global-actions-dropdown />
            </div>
            <div class="ImproverNavbar-item is-suite">
              <app-suite-dropdown />
            </div>
            @if (!profileMenu()) {
              @defer (when !profileMenu()) {
                <div class="ImproverNavbar-item is-cart">
                  <lay-marketplace-notification />
                </div>
              }
            }
          }
        }
        <div
          *app-desktop
          class="ImproverNavbar-item is-helpCenter">
          <app-help-center-dropdown />
        </div>
        <div class="ImproverNavbar-item is-inbox">
          @defer (when !profileMenu()) {
            <app-inbox [profileMenu]="profileMenu()" />
          }
        </div>
        @if (offcanvasVisible && !profileMenu()) {
          @defer (when offcanvasVisible && !profileMenu()) {
            <div
              *app-mobile
              app-custom-theme
              class="ImproverNavbar-item is-sidebar">
              <lay-improver-sidebar-mobile />
            </div>
          }
        }
        <div class="ImproverNavbar-item is-profile">
          <app-profile-dropdown
            [profileMenu]="profileMenu()"
            [companyEmployees]="companyEmployees$ | async" />
        </div>
      </div>
    }
  </nav>
  <ng-template #contextMenu>
    <imp-context-menu-item
      [label]="'APP_NAVIGATION_CONTEXT_MENU_SKIP_TO_MAIN_MENU' | translate"
      icon="chevron-right"
      (action)="skipTo(skipToSubject.navbar)" />
    <imp-context-menu-item
      [label]="'APP_NAVIGATION_CONTEXT_MENU_SKIP_TO_NAVIGATION' | translate"
      icon="chevron-right"
      (action)="skipTo(skipToSubject.sideNavigation)" />
    <imp-context-menu-item
      [label]="'APP_NAVIGATION_CONTEXT_MENU_SKIP_TO_PAGE_CONTENT' | translate"
      icon="chevron-right"
      (action)="skipTo(skipToSubject.content)" />
  </ng-template>
}
